import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function CampaignLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { Campaigns } = useStore();
  const campaign = Campaigns.get(id);
  return (
    <div className={classNames({ [skeleton]: campaign.isPending }, className)}>{campaign.name}</div>
  );
}

export default observer(CampaignLabel);
